export default "__VITE_ASSET__UCU137gy__"